<template>
  <header class="flex items-center justify-end gap-3 h-8 w-full">
    <nav-plants />
    <select-locale />
    <button-user-avatar />
  </header>
</template>
